module.exports = __webpack_public_path__ + "static/comachi_sample_05-3378bbb8700ea8c80fba8b24ee1e3909.png";